import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiRegister, apiLogin, apiGoogleSession, apiMe, setToken, getToken } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

const GOOGLE_AUTH_URL = "https://auth.emergentagent.com/";

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = loading, false = unauth, object = authed
  const [bootError, setBootError] = useState(null);

  const refresh = useCallback(async () => {
    if (!getToken()) { setUser(false); return null; }
    try {
      const me = await apiMe();
      setUser(me);
      return me;
    } catch {
      setToken(null);
      setUser(false);
      return null;
    }
  }, []);

  // Handle Google OAuth redirect (#session_id=...) then normal session boot
  useEffect(() => {
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (match) {
      (async () => {
        try {
          const { access_token, user: u } = await apiGoogleSession(match[1]);
          setToken(access_token);
          setUser(u);
        } catch (e) {
          setBootError("Google sign-in failed. Please try again.");
          setUser(false);
        } finally {
          window.history.replaceState(null, "", window.location.pathname + window.location.search);
        }
      })();
    } else {
      refresh();
    }
  }, [refresh]);

  const login = async (email, password) => {
    const { access_token, user: u } = await apiLogin(email, password);
    setToken(access_token);
    setUser(u);
  };
  const register = async (email, password, name) => {
    const { access_token, user: u } = await apiRegister(email, password, name);
    setToken(access_token);
    setUser(u);
  };
  const loginWithGoogle = () => {
    const redirect = window.location.origin;
    window.location.href = `${GOOGLE_AUTH_URL}?redirect=${encodeURIComponent(redirect)}`;
  };
  const logout = () => {
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, loginWithGoogle, logout, refresh, bootError }}>
      {children}
    </AuthContext.Provider>
  );
};
